import { Component } from '@angular/core';

@Component({
  selector: 'app-admin',
  template: '<router-outlet></router-outlet>',
  styleUrls: []
})
export class AdminComponent{
}
